import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { SEO } from '@/components/SEO';
import { gtag, GOOGLE_ADS_ID } from '@/utils/gtag';

const ThankYou = () => {
  useEffect(() => {
    // Fire Google Ads conversion on page load
    gtag('event', 'conversion', {
      send_to: 'AW-1049756763/u8qKCNm3sIIcENuIyPQD',
    });

    gtag('event', 'generate_lead', {
      currency: 'EUR',
      value: 60,
      form_type: 'reservation',
    });
  }, []);

  return (
    <>
      <SEO
        title="Merci pour votre demande | Le Château de Clémentine"
        description="Votre demande de réservation a bien été reçue. Nous vous recontacterons dans les plus brefs délais."
        noIndex
      />
      <Header />
      <main className="min-h-[70vh] flex items-center justify-center py-20">
        <div className="container mx-auto px-4 text-center max-w-2xl">
          <div className="mb-8 flex justify-center">
            <div className="rounded-full bg-primary/10 p-6">
              <CheckCircle className="h-16 w-16 text-primary" />
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl font-display font-bold mb-6 text-foreground">
            Merci pour votre demande !
          </h1>

          <p className="text-xl text-muted-foreground mb-4 leading-relaxed">
            Votre demande de réservation a bien été reçue et enregistrée.
          </p>
          <p className="text-lg text-muted-foreground mb-10 leading-relaxed">
            Nous vous recontacterons dans les <strong className="text-foreground">plus brefs délais</strong> pour confirmer votre réservation.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg">
              <Link to="/">
                <Home className="mr-2 h-5 w-5" />
                Retour à l'accueil
              </Link>
            </Button>
            <Button asChild variant="secondary" size="lg">
              <Link to="/chateaux">
                🏰 Voir nos châteaux
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ThankYou;
